// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"93465b6a","598":"61e38416","787":"0085a9a7"}[chunkId] + ".chunk.js";
};